/* eslint-disable no-undef */
import React from "react";
import FunctionalityButton from "./FunctionalityButton";
import { getToken } from "@/helpers/accessTokenHelper";
import { ensureDocumentSaved } from "@/taskpane/utility/ensureDocumentSaved";
import { getDocumentLink, getDriveItemId, getIsCompared, getIsRedlined, getPdfUrl } from "@/helpers/fallback-response-helper";

export default function Share({
  refreshDocument,
  setRefreshDocument,
  selected,
  setSelected,
  hovered,
  setHovered,
  heading,
}) {
  let document = JSON.parse(sessionStorage.getItem("document"));

  function openShareDialog(messageToShareDialog) {
    Office.context.ui.displayDialogAsync(
      `${process.env.BASE_URL}/Share.html`,
      {
        width: 58,
        height: 65,
        backgroundColor: "#EFECF9",
        displayInIframe: true,
      },
      (result) => {
        if (result.status === Office.AsyncResultStatus.Failed) {
          if (result.error.code === 12007) {
            openShareDialog(messageToShareDialog);
            // Recursive call
          } else {
            // Handle other errors
          }
        } else {
          let dialog = result.value;
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
            var message = JSON.parse(arg.message);
            if (message.type === "IAmReady") {
              dialog.messageChild(messageToShareDialog);
            }
            if (message.type === "close") {
              dialog.close();
            }
            if (message.type === "refresh") {
              setRefreshDocument(!refreshDocument);
            }
          });
        }
      }
    );
  }

  const share = async () => {
    setSelected && setSelected(heading);
    (JSON.parse(sessionStorage.getItem("document")).fileType !== "sent"
      ? ensureDocumentSaved()
      : Promise.resolve(true)
    ).then(async (saved) => {
      if (!saved) {
        setSelected && setSelected("");
        return;
      }
      let access_token = await getToken();
      const messageToShareDialog = JSON.stringify({
        token: access_token,
        url: getDocumentLink(document),
        sharePDF: false,
        data: document,
      });
      if (getIsCompared(document)) {
        Office.context.ui.displayDialogAsync(
          `${process.env.BASE_URL}/SharePDF.html`,
          {
            width: 40,
            height: 53,
            backgroundColor: "#EFECF9",
            displayInIframe: true,
          },
          (result) => {
            let dialog = result.value;
            dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
              let message = JSON.parse(arg.message);
              if (message.type === "IAmReady") {
                dialog.messageChild(messageToShareDialog);
              }
              if (message.type === "open") {
                dialog.close();
                setTimeout(() => { 
                  if (message?.data?.sharePDF) {
                    let newMsg = JSON.parse(messageToShareDialog);
                    newMsg = { ...newMsg, sharePDF: true };
                    openShareDialog(JSON.stringify(newMsg));
                  } else {
                    openShareDialog(messageToShareDialog);
                  }
                }, 2000);
              }
              if (message.type === "close") {
                dialog.close();
              }
              if (message.type === "refresh") {
                setRefreshDocument(!refreshDocument);
              }
            });
          }
        );
      } else {
        let newMsg = JSON.parse(messageToShareDialog);
        let pdfUrl = getPdfUrl(document);
        newMsg = { ...newMsg, sharePDF: pdfUrl ? true : false };
        openShareDialog(JSON.stringify(newMsg));
      }
    });
  };

  return (
    <div>
      <FunctionalityButton
        buttonText={heading}
        color="#2b579a"
        onClickFunction={share}
        selected={selected}
        hovered={hovered}
        setHovered={setHovered}
      />
    </div>
  );
}
